module.exports = __webpack_public_path__ + "static/media/bmh.3ca1e3bb.png";